<template>
  <div>
    <a-form class="simiot-nested-search-form" :form="form" @submit="handleSearch">
      <a-row :gutter="24">
        <a-col :span="8" :xxl="6">
          <a-form-item label="供应商">
            <a-select
              v-decorator="['profile_supplier_id']"
              allow-clear
              show-search
              option-filter-prop="children"
              placeholder="请选择"
              :loading="loadingSupplierOptions"
            >
              <a-select-option
                v-for="opt in supplierOptions"
                :key="opt.id"
                :value="opt.id"
              >
                {{ opt.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :span="8" :xxl="6">
          <a-form-item label="ICCID">
            <a-input v-decorator="['iccid']" allow-clear placeholder="支持模糊查询" />
          </a-form-item>
        </a-col>

        <a-col :span="8" :xxl="6">
          <a-form-item label="IMSI">
            <a-input v-decorator="['imsi']" allow-clear placeholder="支持模糊查询" />
          </a-form-item>
        </a-col>

        <a-col :span="8" :xxl="6">
          <a-form-item label="MSISDN">
            <a-input v-decorator="['msisdn']" allow-clear placeholder="支持模糊查询" />
          </a-form-item>
        </a-col>

        <a-col :span="8" :xxl="6">
          <a-form-item label="状态">
            <a-select v-decorator="['status']" allow-clear placeholder="请选择">
              <a-select-option :value="0">未使用</a-select-option>
              <a-select-option :value="1">已使用</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :span="8" :xxl="6">
          <a-form-item>
            <a-button type="primary" html-type="submit">查询</a-button>
            <a-button style="margin-left: 8px" @click="handleReset">重置</a-button>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>

<script>
import { findProfileSuppliers } from '@/api/profile_supplier'

export default {
  name: 'SearchProfileData',
  data() {
    return {
      form: this.$form.createForm(this, { name: 'search_profile_datas' }),
      supplierOptions: [],
      loadingSupplierOptions: false
    }
  },
  created() {
    this.fetchSupplierOptions()
  },
  methods: {
    fetchSupplierOptions() {
      this.loadingSupplierOptions = true
      findProfileSuppliers({ page: 1, per_page: 500 }).then((res) => {
        if (res.code === 0) this.supplierOptions = res.data
        this.loadingSupplierOptions = false
      })
    },
    handleSearch(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (err) return
        this.$emit('submit', values)
      })
    },
    handleReset() {
      this.form.resetFields()
      this.$emit('submit', {})
    }
  }
}
</script>
